import React from 'react';
import { useEffect } from 'react';
import useComponentState from '../../utils/useComponentState';
import styles from './PendingCreditTopUp.module.scss';
import { connect } from 'react-redux';
import { PageHeader, Pagination } from '../../components';
import Search from '../../components/Search/Search.component';
import SearchByDate from '../../components/SearchByDate/SearchByDate.components';
import { Button, CloseButton, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import CheckableDataTable from '../../components/CheckableDataTable/CheckableDataTable';
import { completeTopup, getAllPendingTopups } from '../../api/CreditTopup';
import { useGetQueryParams } from '../../hooks/useGetQueryParams';
import { APP_PARAMS } from '../../constants/appParams';
import { useSetQueryParams } from '../../hooks/useSetQueryParams';
import { Drawer } from 'rsuite';
import AddTopUpsModal from '../../components/Modals/AddTopUpsModal';
import { toast } from 'react-toastify';

const PendingCreditTopUp = (props) => {
  const queryParams = useGetQueryParams(
    [
      APP_PARAMS.PAGE,
      APP_PARAMS.START_DATE,
      APP_PARAMS.END_DATE,
      APP_PARAMS.SEARCH_KEY,
      APP_PARAMS.SELECTED
    ]
  );
  const setQueryParam = useSetQueryParams();
  const [state, setState] = useComponentState({
    tableHeading: {
        column: [
            'id',
            'Client Name',
            'Client ID',
            'Requested On',
            'Top Up Amount'
        ],
    },
    loading: false,
    searchKey: '',
    startDate: null,
    endDate: null,
    checkedRows: [],
    isCompletingTopUp: false,
    isSelected: false,
    selectAll: false,
    currentPage: 0,
    totalPages: 1,
    pendingTopUps: [],
    fetchError: false,
    notFoundMessage: 'No Pending Client Top Up found',
    showDrawer: false,
    showAddTopUpModal: false,
    drawerData: {}
  });
  const {
    tableHeading,
    loading,
    searchKey,
    startDate,
    endDate,
    checkedRows,
    isCompletingTopUp,
    isSelected,
    selectAll,
    currentPage,
    totalPages,
    pendingTopUps,
    fetchError,
    notFoundMessage,
    showDrawer,
    showAddTopUpModal,
    drawerData
  } = state;

  const handleSearch = () => {
    setQueryParam({[APP_PARAMS.SEARCH_KEY]: searchKey, [APP_PARAMS.PAGE]: 1});
    setState({ currentPage: 0 });
    fetchClientTopUps(0, {
      searchKey : searchKey,
      startDate: startDate ? startDate.toISOString().split('T')[0] + 'T00:00:00.000Z' : null,
      endDate: endDate ? endDate.toISOString().split('T')[0] + 'T23:59:59.999Z' : null,
    });
  };

  const handleClearPress = () => {
    setQueryParam({[APP_PARAMS.SEARCH_KEY]: null, [APP_PARAMS.PAGE]: 1});
    setState({ searchKey: '', currentPage: 0 });
    fetchClientTopUps(0, {
      startDate: startDate ? startDate.toISOString().split('T')[0] + 'T00:00:00.000Z' : null,
      endDate: endDate ? endDate.toISOString().split('T')[0] + 'T23:59:59.999Z' : null
    });
  };

  const searchOnChange = (value) => {
    setState({ searchKey: value });
  };

  const onChangeStartDate = (date) => {
    const formatedStartDate = date ? date.toISOString().split('T')[0] + 'T00:00:00.000Z' : null;
    setQueryParam({[APP_PARAMS.START_DATE]: formatedStartDate, [APP_PARAMS.PAGE]: 1});
    setState({ startDate: date });
    if (endDate && date) {
      fetchClientTopUps(0, {
        startDate: formatedStartDate,
        endDate: endDate.toISOString().split('T')[0] + 'T23:59:59.999Z',
        searchKey: searchKey
      });
    } else if (!endDate && !date) {
      fetchClientTopUps(0, {
        searchKey: searchKey ? searchKey : null
      });
    }
  };

  const onChangeEndDate = (date) => {
    const formatedEndDate = date ? date.toISOString().split('T')[0] + 'T23:59:59.999Z' : null;
    setQueryParam({[APP_PARAMS.END_DATE]: formatedEndDate, [APP_PARAMS.PAGE]: 1});
    setState({ endDate: date });
    if (startDate && date) {
      fetchClientTopUps(0, {
        startDate: startDate.toISOString().split('T')[0] + 'T00:00:00.000Z',
        endDate: formatedEndDate,
        searchKey: searchKey
      });
    } else if (!startDate && !date) {
      fetchClientTopUps(0, {
        searchKey: searchKey ? searchKey : null
      });
    }
  };

  const handleCompleteTopUps = async () => {
    setState({ isCompletingTopUp: true });

    try {
      const response = await completeTopup(checkedRows , props.auth.auth.token);
      if (response?.[0]?.status === 'SUCCESSFUL') {
        fetchClientTopUps(currentPage);
        toast.success('Selected top ups completed successfully');
      }

    } catch (error) {

    } finally {
      setState({ isCompletingTopUp: false, checkedRows: [] });
    }
  };

  const handleCheckBoxToggle = (id, event) => {
    event.stopPropagation();
  };
  
  const handleOnClick = (id) => {
    const rowData = pendingTopUps.find((item) => item.id === id);
    setQueryParam({[APP_PARAMS.SELECTED]: id});
    setState({
      showDrawer: true,
      drawerData: rowData,
    })
  };

  const handleDrawerOnHide = () => {
    setQueryParam({ [APP_PARAMS.SELECTED]: null });
    setState({
      showDrawer: !showDrawer,
      editingField: null,
    });
  };

  const handleSelectAll = () => {};
  
  const handleMultipleCheck = (ids) => {
    ids.forEach((id) =>
      checkedRows.includes(parseInt(id))
        ? checkedRows.splice(checkedRows.indexOf(parseInt(id)), 1)
        : checkedRows.push(parseInt(id))
    );
    setState({ checkedRows: [...checkedRows] });
  };
  
  const handlePagination = (page) => {
    setQueryParam({[APP_PARAMS.PAGE]: page + 1});
    setState({ currentPage: page });
    fetchClientTopUps(page)
  };

  const fetchClientTopUps = async (page, payload) => {
    setState({ 
        loading: true, 
        fetchError: '' 
    });
    let request = {
      page: page,
      pageSize: 10,
      SortBy: 'time',
      order: 'desc',
    };

    request = {...request, ...payload}

    try {
          const response = await getAllPendingTopups({
            ...request 
          }, props.auth.auth.token);
              setState({
                pendingTopUps: response.list,
                totalPages: response.totalPageCount,
                currentPage: page,
              });
    } catch (error) {
        setState({ fetchError: error.message || 'Failed to fetch data' });
        setState({ pendingTopUps: [], currentPage: 0 });
    } finally {
        setState({ loading: false });
    }
  };

  useEffect(() => {
    setState({
        searchKey: queryParams.searchKey || '',
        startDate: queryParams.startDate ? new Date(queryParams.startDate) : null,
        endDate: queryParams.endDate ? new Date(queryParams.endDate) : null,
        currentPage: queryParams.page ? parseInt(queryParams.page) - 1 : 0,
    });
    fetchClientTopUps(currentPage, {
        searchKey : queryParams.searchKey || '',
        startDate: queryParams.startDate || null,
        endDate: queryParams.endDate || null,
    });
  }, []);

  const renderDetailsDrawer = () => {
    const data = drawerData;
    return (
      <div className='purchase_drawer_root'>
        <div className='drawer_child'>
          <div className='header_group'>
            <div>
              <span className='header_title'>Top Up ID - </span>
              <span className='header_value'>{data.id}</span>
            </div>
            <div>
              <span className='header_title'>Amount - </span>
              <span className='header_value'>{data.topUpValue} LKR</span>
            </div>
          </div>
          <div className={styles.drawer__div}>
            <div className={styles.drawer__child}>
              <div className={styles.details__horizontal}>
                <div className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>Client ID</span>
                  <span className={styles.detail__value}>
                    {data.client?.id}
                  </span>
                </div>
                <div className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>Client Name</span>
                  <span className={styles.detail__value}>
                    {data.client?.clientName}
                  </span>
                </div>
              </div>
              <div className={styles.details__horizontal}>
                <div className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>GlAccount ID</span>
                  <span className={styles.detail__value}>
                    {data.client?.glAccount?.id}
                  </span>
                </div>
                <div className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>GlAccount Name</span>
                  <span className={styles.detail__value}>
                    {data.client?.glAccount?.name}
                  </span>
                </div>
              </div>
              <div className={styles.details__horizontal}>
                <div className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>Created By</span>
                  <div className={styles.details__horizontal}>
                  <div className={styles.detail__group__nested}>
                    <span className={styles.detail__header}>User Email</span>
                    <span className={styles.detail__value}>
                      {data.topUpRequestedBy?.email}
                    </span>
                  </div>
                  <div className={styles.detail__group__nested}>
                    <span className={styles.detail__header}>User Name</span>
                    <span
                      className={styles.detail__value}
                    >{`${data.topUpRequestedBy?.firstName} ${data.topUpRequestedBy?.lastName}`}</span>
                  </div>
                  </div>
                </div>
              </div>
              <div className={styles.details__horizontal}>
                <div className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>Date</span>
                  <span className={styles.detail__value}>{data.time}</span>
                </div>
                <div className={styles.detail__group__nested}>
                  <span className={styles.detail__header}>Status</span>
                  <span className={styles.detail__value}>{data.status}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleAddTopUpModal = () => {
    setState({ showAddTopUpModal: true });
  };

  return (
    <div className={styles.root_div}>
      <div>
        <PageHeader text='Pending Client Top Ups' />
        <div className={styles.search_area}>
          <Search
            placeholder='Search by Client Name, Top Up ID'
            onChange={searchOnChange}
            onClearPress={handleClearPress}
            onBtnPress={handleSearch}
            max={50}
            value={searchKey}
            searchKey={queryParams.searchKey}
            handleValueFromParent={true}
          />
          <SearchByDate
            onStartDateChange={onChangeStartDate}
            onEndDateChange={onChangeEndDate}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      <div className={styles.print_button_block}>
        <div className='mb-3 d-flex align-items-end'>
          {checkedRows.length > 0 && (
            <>
              <span style={{ lineHeight: '24px' }}>
                {checkedRows.length} Top Up
                {checkedRows.length > 1 ? 's' : ''} selected
              </span>
              <span>
                <CloseButton
                  className='ml-2'
                  onClick={() => {
                    setState({ checkedRows: [] });
                  }}
                />
              </span>
            </>
          )}
        </div>
        <div>
          <InputGroup className='mb-3'>
            {(props.role === 'ROLE_THYAGA_ADMINISTRATOR' ||
              props.role === 'ROLE_THYAGA_ACCOUNTANT') && (
              <>
                <Button variant='secondary' onClick={handleAddTopUpModal}>
                  Add Top up
                </Button>
                <Button
                  className='ml-3'
                  onClick={() => handleCompleteTopUps()}
                  disabled={checkedRows.length === 0 || state.isCompletingTopUp}
                >
                  {state.isCompletingTopUp ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className='mr-2' />
                      Completing...
                    </>
                  ) : (
                    'Complete Top Up'
                  )}
                </Button>
              </>
            )}
          </InputGroup>
        </div>
      </div>
      <div>
        <CheckableDataTable
          tableData={pendingTopUps}
          tableheading={tableHeading}
          isSelected={isSelected}
          tag='topups'
          fetchError={fetchError}
          notFoundMessage={notFoundMessage}
          search_filter_loading={loading}
          searchFilterLoading={false}
          handleCheck={handleCheckBoxToggle}
          handleOnClick={handleOnClick}
          handleSelectAll={handleSelectAll}
          handleMultipleCheck={handleMultipleCheck}
          checkedRows={checkedRows}
          selectAll={selectAll}
        />
        {!fetchError && (
          <Pagination
            pageCount={totalPages}
            onChange={handlePagination}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
      <Drawer show={showDrawer} onHide={handleDrawerOnHide}>
        {drawerData && renderDetailsDrawer()}
      </Drawer>
      <AddTopUpsModal
        token={props.auth.auth.token}
        show={showAddTopUpModal}
        handleClose={() => setState({ showAddTopUpModal: false })}
      ></AddTopUpsModal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    role: state.auth.auth.details.role,
  };
};

export default connect(mapStateToProps)(PendingCreditTopUp);
